<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <select class="form-control" v-model="params.costing_item_id" name="costing_item_id">
                                <option value="">Select Costing Item</option>
                                <option v-for="each in costingItems" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr class="form-control" placeholder="Start Date" name="start_date"
                                v-model="params.start_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr class="form-control" placeholder="End Date" name="end_date"
                                v-model="params.end_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="handleSearch">Search</button>
                        </div>
                    </div>
                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                            <tr>
                                <th>SI</th>
                                <th>Costing Item</th>
                                <th class="text-end">Amount</th>
                            </tr>
                            </thead>
                            <template v-if="!loading && reportData['data']?.length > 0">
                                <tbody>
                                <tr v-for="(data,index) in reportData['data']">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ data.costing_item_name }}</td>
                                    <td class="text-end">{{ data['amount'] }}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th class="text-end" colspan="2">Total</th>
                                    <th class="text-end">{{ reportData.total.amount  }}</th>
                                </tr>
                                </tfoot>
                            </template>
                            <template v-if="!loading && reportData['data']?.length === 0">
                                <tr class="text-center">
                                    <td colspan="100" class="fw-bold fs-6 text-height">
                                        No Data Found
                                        <br>
                                        Please search by project.
                                    </td>
                                </tr>
                            </template>

                            <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <p v-if="!loading && reportData['data']?.length > 0" class="mt-2">In Words: <strong>{{ reportData.total.text  }}</strong></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue.vue";
import Table from "../Common/Table.vue";
import Breadcrumb from "../Common/Breadcrumb.vue";
import Unit from "../Settings/Unit/Unit.vue";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Unit, Breadcrumb, Table, ConfirmDialogue},
    data() {
        return {
            breadCrumb: ['Costing Item'],
            reportData: [],
            projects: [],
            costingItems: [],
            params: {
                project_id: '',
                start_date: '',
                end_date: '',
                costing_item_id: ''
            },
            loading: false,
            exportLoading: false,

        }
    },
    methods: {
        downloadFile: function () {
            PrintService.print('/print/costing-item?project_id='+this.params.project_id + '&start_date=' + this.params.start_date + '&end_date=' + this.params.end_date + '&costing_item_id=' + this.params.costing_item_id);
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        handleSearch() {
            this.loading = true;
            ApiService.POST(ApiRoutes.Report + '/costing-item', this.params, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res;
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        fetchCostingItem() {
            ApiService.POST(ApiRoutes.CostingItem + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.costingItems = res.data.data;
                }
            });
        }
    },
    created() {
        this.fetchProject();
        this.fetchCostingItem();
    }
}
</script>

<style scoped>

</style>
